import * as CL from '@design-system/component-library';
import { dsClass } from '../../common/constants/dsClasses';
import {
  cartIsEmptyMsg,
  checkoutMsg,
  continueShoppingMsg,
  monthlyChargesMsg,
  shoppingCartContentPluralMsg,
  shoppingCartContentSingularMsg,
  shoppingCartMsg,
  singleFaresMsg,
  t,
} from '../../common/i18n';
import { ShoppingBasketEntry } from './ShoppingBasketEntry';
import { getProductImage } from './shoppingBasketUiUtils';
import { getTotalAmount } from './shoppingBasketUtils';
import type { BasketItem } from '../../common/types/shoppingBasket';

import './LoadingShoppingBasket.scss';

export interface LoadingShoppingBasketProps {
  basketItems?: BasketItem[];
}

const mapLoadingItems = (basketItems: BasketItem[]) => {
  return basketItems.map(basketItem => {
    return (
      <ShoppingBasketEntry
        key={basketItem.id}
        id={basketItem.id}
        productImage={getProductImage(basketItem.imageUrl, basketItem.name)}
        productName={<span>{basketItem.name}</span>}
        paymentField={
          <div className="of-skeleton-default-width">
            <CL.SkeletonLoader type="button" buttonSize="m" />
          </div>
        }
        quantityField={
          <CL.Quantity
            className={dsClass.SHOPPINGCART_PRODUCT_QUANTITY}
            currentValue={basketItem.quantity}
            minValue={1}
            removeLessThanMin
          />
        }
        price={
          <div className="of-skeleton-price-container">
            <CL.SkeletonLoader type="button" buttonSize="s" />
            <CL.SkeletonLoader type="text" count={1} className={`${dsClass.MARGIN_BOTTOM_0} ${dsClass.MARGIN_TOP_2}`} />
          </div>
        }
        showContractPriceWillBeConfirmedMsg={false}
        addOns={<></>}
      />
    );
  });
};

export const LoadingShoppingBasket = ({ basketItems }: LoadingShoppingBasketProps) => {
  const totalProductQuantity = getTotalAmount(basketItems);
  return (
    <>
      <div className="of-shopping-basket-wrapper of-loading-shopping-basket">
        <div>
          <div className="of-heading-and-company-selector">
            <h1
              className={`${dsClass.H1} ${dsClass.MARGIN_BOTTOM_4}  ${dsClass.MARGIN_TOP_0} of-shopping-basket-header`}
            >
              {t.BE8Q(shoppingCartMsg)}
            </h1>
          </div>
        </div>
        <div className="of-shopping-basket-content">
          <div className={dsClass.MARGIN_TOP_6}>
            <CL.ShoppingCart
              ariaAddonsLabel=""
              ariaPaymentLabel=""
              ariaQuantityDeleteLabel=""
              ariaQuantityLabel=""
              ariaQuantityMinusLabel=""
              ariaQuantityPlusLabel=""
              ariaTotalsLabel=""
              i18nCheckoutLabel={t.UAAP(checkoutMsg)}
              i18nContinueLabel={t.VLZR(continueShoppingMsg)}
              i18nEmptyLabel={t.PRFW(cartIsEmptyMsg)}
              onCheckout={e => {
                e?.preventDefault();
              }}
              i18nHeading=""
              caption={
                totalProductQuantity === 1
                  ? t.I23L(shoppingCartContentSingularMsg)
                  : t.PS1E(shoppingCartContentPluralMsg, `${totalProductQuantity}`)
              }
              items={mapLoadingItems(basketItems || [])}
              totals={[
                {
                  name: t.P6BC(monthlyChargesMsg),
                  amount: '...',
                  unit: '€',
                },
                {
                  amount: '...',
                  name: t.GOBY(singleFaresMsg),
                  unit: '€',
                },
              ]}
              onPaymentOptionChange={() => {}}
              onQuantityChange={() => {}}
              totalProductQuantity={basketItems?.length || 0}
            />
          </div>
        </div>
      </div>
    </>
  );
};
